import React from "react";
import { Truck } from "lucide-react";

const EQUIPMENT_LABELS = {
    reefer: "Reefer",
    dry_van: "Dry Van",
    conestoga: "Conestoga",
    flatbed: "Flatbed",
    step_deck: "Step Deck",
    other: "Other",
};

/**
 * Renders the selected equipment type from a submission's data dict.
 * Falls back gracefully to "Not specified" for pre-Phase-5 submissions.
 *
 * Use `variant="chip"` (default) for compact list rows, `variant="line"` for
 * a labeled, larger header element on detail pages.
 */
export function EquipmentTypeBadge({ data, variant = "chip", className = "", testId = "equipment-badge" }) {
    const raw = data?.equipment_type;
    const other = data?.equipment_type_other;
    const label = raw === "other" ? (other?.trim() || "Other") : (EQUIPMENT_LABELS[raw] || null);

    if (variant === "chip") {
        if (!label) return null;
        return (
            <span
                data-testid={testId}
                className={`inline-flex items-center gap-1 rounded-full bg-blue-50 text-blue-900 text-xs px-2 py-0.5 ${className}`}
            >
                {label}
            </span>
        );
    }

    return (
        <div
            data-testid={testId}
            className={`inline-flex items-center gap-2 rounded-md bg-slate-100 px-3 py-1.5 ${className}`}
        >
            <Truck size={14} className="text-slate-500" />
            <span className="text-xs font-medium tracking-[0.12em] uppercase text-slate-500">Equipment</span>
            <span className="text-sm font-semibold text-slate-900">{label || "Not specified"}</span>
        </div>
    );
}
